import {
  SectionValue,
  RecordPageRenderContext,
  JsonSchemaProperty,
} from "../../../../types";
import {
  RecordPageContent,
  RecordPageSectionLayout,
} from "../../../../utils/styled";
import { SCHEMA_SECTIONS } from "../../constants";
import { isSectionVisible } from "../../helpers";
import { resolveCustomStyle } from "../../style-config";
import { renderField } from "./recordPage.field";
import { renderSectionForm } from "./recordPage.sectionForm";
import { renderSectionHeader } from "./recordPage.sectionHeader";

export function renderSection(
  sectionKey: string,
  sectionValue: SectionValue,
  ctx: RecordPageRenderContext,
  explicitSectionValueWithProperty?: Record<string, JsonSchemaProperty>,
): JSX.Element | null {
  if (sectionKey === SCHEMA_SECTIONS.GRID_FIELDS) return null;

  // Nested (tabbed) section — recurse into sub-sections
  if (!Array.isArray(sectionValue)) {
    return (
      <div key={sectionKey}>
        {Object.entries(sectionValue).map(([key, value]) =>
          renderSection(key, value, ctx),
        )}
      </div>
    );
  }

  // Co-relation fields render flat, with no layout wrapper
  if (sectionKey === SCHEMA_SECTIONS.CORELATION_FIELDS  || sectionKey === SCHEMA_SECTIONS.GROUPED_FIELDS) {
    return (
      <RecordPageContent key={sectionKey}>
        {sectionValue.map((propertyKey) => renderField(propertyKey, ctx))}
      </RecordPageContent>
    );
  }

  // Standard section
  const content = (
    <RecordPageSectionLayout
      key={sectionKey}
      $customStyle={resolveCustomStyle({
        applicability: "section",
        selectedSetup: ctx.selected.setup.value,
        sectionKey,
        isRecordOpen: ctx.isRecordOpen,
        isHidden: !isSectionVisible(sectionValue, ctx.schema),
      })}
    >
      {renderSectionHeader({ sectionKey, ctx })}

      {renderSectionForm({
        sectionKey,
        sectionValue,
        ctx,
        explicitSectionValueWithProperty,
      })}
    </RecordPageSectionLayout>
  );

  return <RecordPageContent key={sectionKey}>{content}</RecordPageContent>;
}
